type DelaySlice = {
    label: string;
    percent: number;
    total: number;
    count: number;
    color: string;
};

interface Props {
    slices: DelaySlice[];
}

const delayIntervals = [
    { color: '#d81900', label: '> 60 min' },
    { color: '#e08700', label: '30–60 min' },
    { color: '#d9d200', label: '15–30 min' },
    { color: '#04aa6d', label: '< 15 min' },
];

export function DelayDistributionBarHorizontal({ slices }: Props) {
    const totalDelayMinutes = slices.reduce((sum, slice) => sum + slice.total, 0);
    const totalDelayItems = slices.reduce((sum, slice) => sum + slice.count, 0);
    const totalDelayHours = Math.floor(totalDelayMinutes / 60);
    const totalDelayRemainderMinutes = totalDelayMinutes % 60;

    return (
        <div style={{ width: '100%' }}>
            <div
                style={{
                    width: '100%',
                    border: '1px solid #999',
                    display: 'flex',
                    flexDirection: 'row',
                    overflow: 'hidden',
                    minHeight: 30,
                }}
            >
                {slices &&
                    [...slices].reverse().map((slice) => (
                        <div
                            key={slice.label}
                            title={`${slice.label}: ${slice.percent}%`}
                            style={{
                                flexGrow: slice.count,
                                flexBasis: 0,
                                minWidth: slice.percent > 0 ? 50 : 0,
                                backgroundColor: slice.color,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 700,
                                fontSize: 13,
                                color: '#000',
                            }}
                        >
                            {slice.percent > 0 ? `${slice.percent}% (${slice.count})` : ''}
                        </div>
                    ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 11, marginTop: 6, gap: 12 }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: 20 }}>
                    {[...delayIntervals].reverse().map((interval) => (
                        <div key={interval.label} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <div
                                style={{
                                    width: 12,
                                    height: 12,
                                    backgroundColor: interval.color,
                                    border: '1px solid #666',
                                }}
                            />
                            <span>{interval.label}</span>
                        </div>
                    ))}
                </div>
                <div style={{ whiteSpace: 'nowrap', fontWeight: 700 }}>
                    Total delay: {totalDelayHours}h {totalDelayRemainderMinutes}m ({totalDelayItems} items)
                </div>
            </div>
        </div>
    );
}